import { Context } from '@layout/domain/store/sidenav/context';

export class SetSidenavContext {
	static readonly type = '[SIDENAV] Set SidenavContext';

	constructor(public context: Context) {}
}
